import { Link, useTheme } from "@mui/material";

interface ShowHiddenToggleProps {
  /** The number of items hidden */
  numHidden: number;

  /** Whether the hidden items are currently shown */
  showHidden: boolean;

  /** Callback to toggle whether the hidden items are shown */
  onToggle: () => void;
}

export function ShowHiddenToggle({
  numHidden,
  showHidden,
  onToggle,
}: ShowHiddenToggleProps) {
  const theme = useTheme();

  return (
    <Link
      component={"button"}
      onClick={onToggle}
      underline="hover"
      color={theme.palette.grey[600]}
      sx={{
        fontSize: theme.typography.overline,
      }}
    >
      {showHidden
        ? `Hide filtered (${numHidden})`
        : `Show filtered (${numHidden})`}
    </Link>
  );
}
